import React from 'react';
import { Star, Pencil, Trash2 } from 'lucide-react';
import { formatDate } from '../../utils/utils';
import './CaseCard.scss';

const CaseCard = ({
  caseItem,
  onView,
  onEdit,
  onDelete,
  onToggleFavorite,
  showActions = true,
  isFavorite = false, // Destructure isFavorite directly from props
  rtl = true, // Default to RTL for Hebrew
}) => {
  // Destructure case details from caseItem
  const { _id, name: title, tags = [], createdAt } = caseItem; // Use _id and name

  const handleClick = () => {
    if (onView) onView(_id); // Use _id
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit(_id); // Use _id
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    // Pass the full caseItem object to the delete handler in CasesList
    if (onDelete) onDelete(caseItem);
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (onToggleFavorite) onToggleFavorite(caseItem);
  };

  // Format date to match the design (DD.MM.YY)
  const formattedDate = formatDate(createdAt, 'short');

  return (
    <div className="case-card" onClick={handleClick} dir={rtl ? 'rtl' : 'ltr'}>
      <div className="case-card-header">
        <button
          className={`favorite-button ${isFavorite ? 'active' : ''}`}
          onClick={handleFavoriteClick}
          aria-label={isFavorite ? 'הסר ממועדפים' : 'הוסף למועדפים'}
        >
          <Star size={18} fill={isFavorite ? '#f4c741' : 'none'} />
        </button>
        <h3 className="case-card-title">{title}</h3>
        <div className="case-card-date">{formattedDate}</div>
      </div>

      {tags.length > 0 && (
        <div className="case-card-tags">
          {tags.map((tag, index) => (
            <span key={index} className="case-card-tag">
              {tag}
            </span>
          ))}
        </div>
      )}

      {showActions && (
        <div className="case-card-actions">
          <button
            className="case-card-action edit"
            onClick={handleEditClick}
            aria-label="ערוך מקרה"
          >
            <Pencil size={16} />
          </button>
          <button
            className="case-card-action delete"
            onClick={handleDeleteClick}
            aria-label="מחק מקרה"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default CaseCard;
